<h1 class="form-title" mat-dialog-title cdkFocusRegionStart><span>Web勤怠申請</span><span>対象日：{{ keySet.dateText }}</span></h1>

<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" class="request-form" #requestForm="ngForm">
    <div class="table-header">
      <p class="row-title"></p>
      <div class="table-header-list">
        <p>出社</p>
        <p>退社</p>
        <p>外出</p>
        <p>戻り</p>
      </div>
    </div>
    <hr>
    <div class="actual-report">
      <p class="row-title">実打刻</p>
      <div class="actual-report-list">
        <p>{{ actualReport[0] }}</p>
        <p>{{ actualReport[1] }}</p>
        <p>{{ actualReport[2] }}</p>
        <p>{{ actualReport[3] }}</p>
      </div>
    </div>
    <hr>
    <div class="request-chips">
      <p class="row-title">申請</p>
      <div class="request-chips-list">
        <div class="ones-chip-list">
          <mat-chip-set>
            <div class="chip-list">
              <mat-chip color="primary" *ngFor="let timeChip of arriveTimeStamps; let i=index" [removable]="removable" (removed)="remove(timeChip, 0)" [selectable]="selectable" selected="{{!arriveTimeStamps[i].disable}}">
                {{ timeChip.dateText }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <div class="add-icon-button">
                <button type="button" mat-icon-button matTooltip="追加" matTooltipPosition="below" (click)="openDialog(0)" *ngIf="arriveTimeStamps.length === 0" [disabled]="!editable">
                <mat-icon>add_circle</mat-icon>
                </button>
              </div>
            </div>
          </mat-chip-set>
        </div>
        <div class="ones-chip-list">
          <mat-chip-set>
            <div class="chip-list">
              <mat-chip color="primary" *ngFor="let timeChip of leaveTimeStamps; let i=index" [removable]="removable" (removed)="remove(timeChip, 1)" [selectable]="selectable" selected="{{!leaveTimeStamps[i].disable}}">
                {{ timeChip.dateText }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <div class="add-icon-button">
                <button type="button" mat-icon-button matTooltip="追加" matTooltipPosition="below" (click)="openDialog(1)" *ngIf="leaveTimeStamps.length === 0" [disabled]="!editable">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </div>
            </div>
          </mat-chip-set>
        </div>
        <div class="ones-chip-list">
          <mat-chip-set>
            <div class="chip-list">
              <mat-chip color="primary" *ngFor="let timeChip of temporaryLeaveTimeStamps; let i=index" [removable]="removable" (removed)="remove(timeChip, 2)" [selectable]="selectable" selected="{{!temporaryLeaveTimeStamps[i].disable}}">
                {{ timeChip.dateText }}
                <mat-icon matChipRemove *ngIf="removable && !timeChip.actual">cancel</mat-icon>
                <mat-icon matChipRemove *ngIf="removable && timeChip.actual && !timeChip.disable">toggle_on</mat-icon>
                <mat-icon matChipRemove *ngIf="removable && timeChip.actual && timeChip.disable">toggle_off</mat-icon>
              </mat-chip>
              <div class="add-icon-button">
                <button type="button" mat-icon-button matTooltip="追加" matTooltipPosition="below" (click)="openDialog(2)" *ngIf="previewDate[2].length <= 3" [disabled]="!editable">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </div>
            </div>
          </mat-chip-set>
        </div>
        <div class="ones-chip-list">
          <mat-chip-set>
            <div class="chip-list">
              <mat-chip color="primary" *ngFor="let timeChip of reenterTimeStamps; let i=index" [removable]="removable" (removed)="remove(timeChip, 3)" [selectable]="selectable" selected="{{!reenterTimeStamps[i].disable}}">
                {{ timeChip.dateText}}
                <mat-icon matChipRemove *ngIf="removable && !timeChip.actual">cancel</mat-icon>
                <mat-icon matChipRemove *ngIf="removable && timeChip.actual && !timeChip.disable">toggle_on</mat-icon>
                <mat-icon matChipRemove *ngIf="removable && timeChip.actual && timeChip.disable">toggle_off</mat-icon>
              </mat-chip>
              <div class="add-icon-button">
                <button type="button" mat-icon-button matTooltip="追加" matTooltipPosition="below" (click)="openDialog(3)" *ngIf="previewDate[3].length <= 3" [disabled]="!editable">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </div>
            </div>
          </mat-chip-set>
        </div>
      </div>
    </div>
    <hr>
    <div class="preview">
      <p class="row-title">プレビュー</p>
      <div class="preview-list">
        <p>{{ preview[0] }}</p>
        <p>{{ preview[1] }}</p>
        <p>{{ preview[2] }}</p>
        <p>{{ preview[3] }}</p>
      </div>
    </div>
    <hr>
    <mat-form-field *ngIf='user?.authority <= 1 && !isMobile'>
      <mat-select placeholder="承認者" id="approver" [disabled]="!editable" [(ngModel)]="approverUid" name="approver" #approver="ngModel"
        required>
      <mat-option *ngFor="let a of approvers" [value]="a.uid">{{a.teamName}} -> {{a.displayName}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf='user?.authority <= 1 && isMobile'>
      <select matNativeControl placeholder="承認者" id="approver" [disabled]="!editable" [(ngModel)]="approverUid" name="approver" #approver="ngModel"
        required>
      <option *ngFor="let a of approvers" [value]="a.uid">{{a.teamName}} -> {{a.displayName}}</option>
      </select>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="理由" id="cause" [disabled]="!editable" [(ngModel)]="keySet.cause" name="cause" #cause="ngModel"
      required>
      <mat-error *ngIf="cause.errors?.required">理由の入力は必須です</mat-error>
    </mat-form-field>
    <div>
      <button type="submit" mat-raised-button color="primary" [disabled]="requestForm.invalid || submitting || !editable">登録</button>
    </div>
  </form>

</div>
